var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2450_27899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3997 48H12.6971C10.7327 48 9.41617 45.9624 10.2438 44.1808C10.2489 44.1698 11.0216 42.39 13.1325 42.0033C13.8634 41.8696 14.5109 41.4452 14.9496 40.8453C15.9446 39.4841 17.5779 38.6188 19.4093 38.6905C22.1003 38.796 24.3019 40.9607 24.4502 43.6494C24.5143 44.8158 24.1983 45.9053 23.6149 46.8051C23.129 47.5536 22.2922 48 21.3997 48Z",
    fill: "#9AD880"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6142 46.8051C24.1975 45.9053 24.5139 44.8158 24.4495 43.6494C24.4165 43.0478 24.2807 42.4728 24.0595 41.9407C22.9216 41.614 20.9723 41.2647 18.9959 41.8825C16.6639 42.6112 15.1818 45.3703 15.6985 48H21.3989C22.2918 48 23.1286 47.5536 23.6142 46.8051Z",
    fill: "#8DC971"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9421 48H20.9922V3.47498C20.9922 1.55566 22.5479 0 24.4672 0C26.3861 0 27.9421 1.55566 27.9421 3.47498V48Z",
    fill: "#C68D6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1594 3.46619C23.1235 2.08813 23.4626 0.898315 23.8036 0.0640869C22.2021 0.373901 20.9922 1.78271 20.9922 3.47498V40.6124C24.1189 40.9991 26.3956 40.1067 27.9421 39.0322V6.17212C27.2548 6.16919 26.5677 6.16736 25.9532 6.16809C24.4456 6.16956 23.199 4.97351 23.1594 3.46619Z",
    fill: "#B2785B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8008 15.9558V11.7821C11.8008 9.83716 13.6981 8.26062 16.0386 8.26062H35.0881C37.0807 8.26062 38.9963 8.89893 40.437 10.043L43.2686 12.2919C44.3503 13.151 44.3503 14.5869 43.2686 15.446L40.437 17.6949C38.9963 18.839 37.0807 19.4773 35.0881 19.4773H16.0386C13.6981 19.4773 11.8008 17.9008 11.8008 15.9558Z",
    fill: "#FF929F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5073 15.9562V11.7821C19.5073 9.83716 21.405 8.26062 23.7455 8.26062H16.0386C13.6981 8.26062 11.8008 9.83716 11.8008 11.7821V15.9562C11.8008 17.9008 13.6981 19.4773 16.0386 19.4773H23.7455C21.405 19.4773 19.5073 17.9008 19.5073 15.9562Z",
    fill: "#FF737D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3105 31.1536V27.0483C36.3105 25.1356 34.4131 23.5851 32.0727 23.5851H13.0231C11.0305 23.5851 9.1149 24.2131 7.67422 25.3381L4.84232 27.55C3.76089 28.3949 3.76089 29.8066 4.84232 30.6519L7.67422 32.8638C9.11453 33.9888 11.0305 34.6165 13.0231 34.6165H32.0727C34.4131 34.6165 36.3105 33.0663 36.3105 31.1536Z",
    fill: "#77E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.331 30.6519C12.2492 29.807 12.2492 28.3949 13.331 27.55L16.1629 25.3381C17.6032 24.2128 19.5192 23.5851 21.5118 23.5851H13.023C11.0305 23.5851 9.11481 24.2131 7.67413 25.3381L4.84259 27.55C3.7608 28.3949 3.7608 29.8066 4.84259 30.6519L7.67413 32.8638C9.11481 33.9888 11.0305 34.6165 13.023 34.6165H21.5118C19.5192 34.6165 17.6032 33.9888 16.1629 32.8638L13.331 30.6519Z",
    fill: "#5ED3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5333 48H36.236C38.2003 48 39.5169 45.9624 38.6892 44.1808C38.6841 44.1698 37.9114 42.39 35.8005 42.0033C35.0696 41.8696 34.4221 41.4452 33.9834 40.8453C32.9884 39.4841 31.3551 38.6188 29.5237 38.6905C26.8328 38.796 24.6307 40.9607 24.4828 43.6494C24.4187 44.8158 24.7347 45.9053 25.3181 46.8051C25.8041 47.5536 26.6409 48 27.5333 48Z",
    fill: "#B2E59C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2450_27899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirections);
export default __webpack_public_path__ + "static/media/directions.cd6650abaa5273a561ac44a1fdfaae82.svg";
export { ForwardRef as ReactComponent };